<template>
    <b-col class="score-trend-widget"
           :class="{'is-indicator-light': isIndicatorLight}">

        <div @click.stop="showModal()">
            <div v-if="widget.meters" class="meter-widget col">
                <div v-for="(m,i) in widget.meters" :key="`meter_${i}`" class="meter">
                    <score-trend-chart :scoreSeriesDef="participantScores[m.scoreName]"
                                       v-if="!excludeChart(m.scoreName)">
                    </score-trend-chart>
                </div>
            </div>
            <div v-else-if="widget.indicatorLight">
                <report-indicator-light-mini :score-name="widget.indicatorLight.scoreName"
                                             :label-key="`LABEL_${widget.indicatorLight.scoreName}`"
                                             :show-always="true">
                </report-indicator-light-mini>
            </div>
            <div v-else-if="widgetKey == 'FRAMINGHAM_SCORE'" class="mx-2">
                <label>{{ $i18n.gt('LABEL_FRAMINGHAM') }}</label>
                <report-score-framingham></report-score-framingham>
            </div>
            <div v-else-if="widgetKey == 'ACC_AHA_SCORE'" class="mx-2">
                <label>{{ $i18n.gt('LABEL_ASCVD') }}</label>
                <report-score-acc-aha></report-score-acc-aha>
            </div>
        </div>

        <!-- details modal -->
        <report-widget-details-modal :widget-key="widgetKey">
            <!-- slot for Framingham, ACC_AHA (or other custom content) -->
            <slot></slot>
        </report-widget-details-modal>

    </b-col>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import ReportMixin from '@/providers/ReportMixin'
import ReportScoreFramingham from "@/components/ReportScoreFramingham";

/**
 * Displays a trend chart or indicator light for an individual score.
 * Clicking the widget opens a modal with additional information.
 */
export default Vue.extend({
    name: 'ScoreTrendWidget',
    components: {ReportScoreFramingham},
    mixins: [ReportMixin],
    props: {
        widgetKey: String,
        isIndicatorLight: Boolean
    },
    computed: {
        useDietId() {
            return this.$store.state.patientParticipantProviderUsesDietId
        },
        widget() {
            return this.getWidgets()[this.widgetKey] // see ReportMixin
        },
        participantScores() {
            return this.$store.state.participantScores
        },
        modalId() {
            return `modal_${this.widgetKey}`
        },
    },
    methods: {
        // only show one diet chart, depending on setting for practice
        excludeChart(scoreName) {
            return this.useDietId && scoreName == 'SCORE_DIET' ||
                !this.useDietId && scoreName == 'SCORE_DIETID'
        },
        showModal() {
            this.$bvModal.show(this.modalId)
        },
        getMeterLabel(meter) {
            if (meter.labelKey) {
                return this.$i18n.gt(meter.labelKey)
            } else if (meter.biometric && meter.biometric.labelKey) {
                return this.$i18n.gt(meter.biometric.labelKey)
            } else {
                return ''
            }
        }
    }
})
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

.score-trend-widget {
    cursor: pointer;
    padding: 0 !important;
    background: transparent;
    transition: all .3s;
    border: solid 1px var(--border-color);
    margin-bottom: .5em;

    &.is-indicator-light {
        border: none;
    }

    .badge {
        margin-bottom: 0;

        &:hover {
            background-color: var(--btn-bg-hover);
            color: #fff;
        }
    }

    .score-trend-chart {
        background-color: #fff;
    }
}

.meter-widget {
    padding: 0 !important;

    &:hover {
        box-shadow: 0 0 10px rgba(0, 0, 0, .15);
    }
}

.report-indicator-light-mini {
    //margin-bottom: .5em;
    //padding:0!important;
    .badge {
        //padding-top:1em;
        //padding-bottom:1em;
    }
}

</style>
